import { Form, FormInstance, FormProps } from 'antd'
import React, { ReactNode, useCallback, useState } from 'react'

import FormModal, { FormModalProps } from '@/components/shared/form-modal'


export interface UseFormModalParams<Values> {
  onSubmit: FormModalProps<Values>['onSubmit']
  getFields: (form: FormInstance, modalOpen: boolean) => ReactNode
  title: string
  formProps?: FormModalProps<Values>['formProps']
  modalProps?: FormModalProps<Values>['modalProps']
  submitText?: FormModalProps<Values>['submitText']
  cancelText?: FormModalProps<Values>['cancelText']
}

export default function useFormModal<Values>(
  {
    onSubmit,
    getFields,
    title,
    formProps,
    modalProps,
    submitText,
    cancelText,
  }: UseFormModalParams<Values>) {
  const [form] = Form.useForm<Values>()
  const [modalOpen, setModalOpen] = useState(false)
  const [initialValues, setInitialValues] =
    useState<FormProps<Values>['initialValues']>(undefined)

  const formModal = (
    <FormModal
      form={form}
      open={modalOpen}
      setOpen={setModalOpen}
      onSubmit={onSubmit}
      modalProps={{ title, ...modalProps }}
      submitText={submitText}
      cancelText={cancelText}
      formProps={{ initialValues, layout: 'vertical', ...formProps }}
    >
      {getFields(form, modalOpen)}
    </FormModal>
  )
  const open = useCallback(
    (newInitialValues?: FormProps<Values>['initialValues']) => {
      if (initialValues !== newInitialValues) {
        setInitialValues(newInitialValues)
        if (newInitialValues) {
          form.setFieldsValue(newInitialValues)
        }
      }
      setModalOpen(true)
    },
    [form, initialValues],
  )
  const close = useCallback(() => setModalOpen(false), [])

  return [formModal, open, close, form] as const
}
